"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegexLib = void 0;
var RegexLib = /** @class */ (function () {
    function RegexLib() {
    }
    /**
     * Firs- or Lastname regex
     */
    RegexLib.Name = {
        _: /^[A-Za-zäüöÄÜÖß.\- ]+$/,
    };
    RegexLib.City = {
        _: /^[A-Za-zäüöÄÜÖß.\-() ]+$/
    };
    RegexLib.Street = {
        _: /^[A-Za-zäüöÄÜÖß\- ]+\.? ?(\d+)*[A-Za-z ]*$/,
        WITH_BACKSLASH: /^[A-Za-zäüöÄÜÖß\- ]+\.? ?(\d+)*( ?\/ ?\d+)?[A-Za-z ]*$/
    };
    RegexLib.Zip = {
        _: /(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})/
    };
    RegexLib.Phone = {
        _: /^[+]?[0-9]{1,16}$/,
        mobile: /^0[0-9]{9,16}$/
    };
    RegexLib.Birthday = {
        _: /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/
    };
    RegexLib.KfzLicensePlate = {
        _: /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/
    };
    return RegexLib;
}());
exports.RegexLib = RegexLib;
